import Queue from './Queue.container';

export default Queue;
